import React, { useState, useEffect, useRef, useCallback } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { ProgressBar } from "primereact/progressbar";
import { Badge } from "primereact/badge";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { TabView, TabPanel } from "primereact/tabview";
import { FileUpload } from "primereact/fileupload";
import { addLocale } from "primereact/api";
import { Calendar } from "primereact/calendar";
import classNames from "classnames";
import { Toast } from "primereact/toast";
import { loading, setUsuarioLogin } from "../../actions";
import { getListaAsistencia, registroAsistencia } from "../../service/Asistencia";

import { Image } from "primereact/image";
import { useDispatch, useSelector } from "react-redux";
import { InputTextarea } from "primereact/inputtextarea";
import moment from "moment";
import { InputSwitch } from "primereact/inputswitch";
import { FiltroNivelCurso } from "../../components/FiltroNivelCurso";
import "./StepsDemo.css";
import { isNotVacioNull, isEmail, isRun, isLetras, isLetrasEspacio, minMax, isValue, isTelefono, getResultValidar } from "../../utilities/Validate";
//import * as XLSX from 'xlsx';
import { useHistory } from "react-router-dom";
import { accionPermiso } from "../../utilities/Seguridad";
import { Tooltip } from "primereact/tooltip";
import { ScrollPanel } from "primereact/scrollpanel";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
import { getMeses, getMesDias } from "../../utilities/Funcion";
import { MultiStateCheckbox } from "primereact/multistatecheckbox";

export const PageAsistencia = () => {
    const [dataFicha, setDataFicha] = useState(null);
    const [loading1, setLoading1] = useState(false);
    const [displayResponsive, setDisplayResponsive] = useState(false);
    const [array, setArray] = useState([]);
    const [subir, setSubir] = useState(false);

    const toast = useRef(null);
    const fileUpload = useRef(null);
    const arraySave = useRef([]);
    const idCurso = useRef(null);

    // Reset Filtros Curso y grado
    const filtroRef = useRef(null);

    const dispatch = useDispatch();
    const [mes, setMes] = useState("11");
    const [columnsDias, setColumnsDias] = useState([]);
    const listaMeses = getMeses();

    // Permisos
    const history = useHistory();
    const permisos = useRef({ superusuario: false, acciones: [] });
    const { usuario, colegio, anio } = useSelector((state) => ({
        usuario: state.usuario,
        colegio: state.colegio,
        anio: state.anio,
    }));

    const onMesChange = (e) => {
        setMes(e.value);
    };

    const optionsAsistio = [
        //{ value: 0, icon: 'pi pi-globe' },
        { value: 1, icon: "pi pi-check" },
        { value: 2, icon: "pi pi-times" },
    ];

    try {
        permisos.current.superusuario = usuario.superusuario;
        permisos.current.acciones = usuario.permisos.registros.ficha_estudiante.acciones;
    } catch (error) {
        permisos.current.acciones = [];
    }
    //----------------------------


    addLocale("es", {
        firstDayOfWeek: 1,
        dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
        dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
        dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
        monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
        monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
        today: "Hoy",
        clear: "Claro",
    });

    const getFiltroNivelCurso = useCallback(
        (data) => {
            if (!data.es_nivel) {
                idCurso.current = data.id;
                loadListaAsistencia()
            }
        },
        [dataFicha]
    );

    useEffect(() => {
        /*
        if (accionPermiso(permisos, "ficha_ver")) {
            loadListaAsistencia();
        } else {
            history.push("/Acceso");
        }

        */
        //  setColumnsDias(getMesDias(anio.anio,parseInt(mes)))
        //window.addEventListener('resize',loadd);
        // return()=>{ window.removeEventListener('resize',loadd);}
    }, [anio]);

    useEffect(() => { 
        loadListaAsistencia();
        setColumnsDias(getMesDias(anio.anio, parseInt(mes)));
    }, [anio, mes]);

    const saveRegistroAsistencia = async () => {
        let stringJson = JSON.stringify(Object.values(arraySave.current));
        dispatch(loading(true));
        var data = await registroAsistencia(colegio.id, idCurso.current, mes,stringJson, usuario.token);
        if (data.error == 0) {
            loadListaAsistencia();
        } else {
            if (data.error == 1) {
                toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
            } else {
                console.log("Error");
            }
        }

        dispatch(loading(false));
    };

    const loadListaAsistencia = async () => {
        //sleep(1).then(async r => {//Código que pausado
        //})
        if (colegio.id !== undefined && idCurso.current !== 0 && idCurso.current !== null) {
            dispatch(loading(true));
            var data = await getListaAsistencia(colegio.id, idCurso.current, parseInt(mes), usuario.token);
            if (data.error == 0) {
                let asistencias = data.asistencia;
                let dataPreparada = [];
                if (asistencias.length > 0) {
                    for (let i = 0; i < asistencias.length; i++) {
                        var arrayDias = {};
                        var arrayAlumno = {
                            idalumno: asistencias[i].idalumno,
                            alumno: asistencias[i].alumno,
                        };

                        let dias = asistencias[i].detalle;
                        for (let j = 0; j < dias.length; j++) {
                            arrayDias[`${dias[j]["fecha"].substring(8, 10)}`] = dias[j];
                        }
                        dataPreparada.push({ ...arrayAlumno, ...arrayDias });
                    }

                    let ord = dataPreparada.sort((a, b) => {
                        let fa = a.alumno.toLowerCase(),
                            fb = b.alumno.toLowerCase();
                        if (fa < fb) {
                            return -1;
                        }
                        if (fa > fb) {
                            return 1;
                        }
                        return 0;
                    });
                    setDataFicha(ord);
                } else {
                    setDataFicha([]);
                }
            } else {
                if (data.error == 1) {
                    toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
                } else {
                    console.log("Error");
                }
                setDataFicha([]);
            }

            arraySave.current = [];

            dispatch(loading(false));
        } else {
            setDataFicha([]);
        }

       
    };

    const exportExcel = () => {
        let dataExportar = [];
        dataFicha?.map((obj) => {
            let o = { ...obj };
            delete o.id;
            delete o.idalumno;
            delete o.digito_verificador;
            delete o.idmatriculapie;
            dataExportar.push(o);
        });

        import("xlsx").then((xlsx) => {
            const worksheet = xlsx.utils.json_to_sheet(dataExportar);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
            const excelBuffer = xlsx.write(workbook, { bookType: "xlsx", type: "array" });
            saveAsExcelFile(excelBuffer, "Fichas");
        });
    };

    const saveAsExcelFile = (buffer, fileName) => {
        import("file-saver").then((FileSaver) => {
            let EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
            let EXCEL_EXTENSION = ".xlsx";
            const data = new Blob([buffer], {
                type: EXCEL_TYPE,
            });
            FileSaver.saveAs(data, fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION);
        });
    };

    const header = (
        <div className="table-header">
            <div className="p-formgrid p-grid p-col-12 p-fluid p-p-0">
                <div className="p-col-12 p-md-2 p-lg-2">
                    <label htmlFor="name5" style={{ fontSize: "16px" }}>
                        Mes:
                    </label>
                    <Dropdown value={mes} options={listaMeses} onChange={onMesChange} optionLabel="name" selected />
                </div>

                <div className="p-col-12 p-md-6 p-lg-3">{accionPermiso(permisos, "ficha_ver") ? <FiltroNivelCurso getFiltroNivelCurso={getFiltroNivelCurso} reset={filtroRef} todos={false} /> : ""}</div>

                <div className="p-col-8 p-md-2 p-lg-2 p-offset-3 p-mt-3" style={{ textAlign: "right" }}>
                    {accionPermiso(permisos, "ficha_exportar") ? <Button type="button" icon="pi pi-file-excel" onClick={exportExcel} className="p-button-success mr-2 p-mr-1" data-pr-tooltip="XLS" /> : ""}
                    <Button type="button" icon="pi pi-refresh" className="mr-2" onClick={loadListaAsistencia}></Button>
                    {accionPermiso(permisos, "ficha_importar_masivo") ? <Button type="button" icon="pi pi-pencil" className="mr-2" style={{ marginLeft: "3px" }} onClick={() => dialogUpload()}></Button> : ""}
                    <Button type="button" icon="pi pi-save" className="mr-2" style={{ marginLeft: "3px" }} onClick={saveRegistroAsistencia}></Button>
                </div>
            </div>
        </div>
    );

    const bodyTemplate = (data, props) => {
        let val = data[props.header]["marca"];
        let dat = { i: props.rowIndex, dia: props.header, row: data };
        return (
            <>
                <MultiStateCheckbox key={props.rowIndex} value={val} options={optionsAsistio} optionValue="value" onChange={(e) => arrayAsistio(e, dat)} />
            </>
        );
    };

    const bodyTemplateNro = (data, props) => {
        return <>{props.rowIndex + 1}</>;
    };

    const bodyTemplateAlumno = (data, props) => {
        return <>{data["alumno"]}</>;
    };

   
    const arrayAsistio = (e, dat) => {
        let val = [...dataFicha];
        val[dat.i][dat.dia].marca = e.value;
        setDataFicha(val);
        arraySave.current[val[dat.i][dat.dia].id] = { id: val[dat.i][dat.dia].id, marca: e.value === null ? 0 : e.value };
    };

    const rowClass = (data) => {
        return {
            "row-accessories": data.idmatriculapie > 0,
        };
    };

    const renderFooter = () => {
        return (
            <div>
                {subir ? <Button label="Subir" icon="pi pi-upload" /> : ""}
                <Button label="Cerrar" icon="pi pi-times" autoFocus />
            </div>
        );
    };

    const dialogUpload = () => {
       

        /*
        setArray([]);
        setDisplayResponsive(true);
        setSubir(false);
      */
    };

    let headerGroup = (
        <ColumnGroup>
            {/* Nombre del día (dos digitos) */}
            <Row>
                <Column header="Nro" rowSpan={3} field="grado" headerStyle={{ width: "50px", minWidth: "50px", textAlign: "center" }} />
                <Column header="Reporte SIGE" headerStyle={{ width: "500px", textAlign: "center" }} />
                {columnsDias?.map((dia, index) => {
                    return <Column key={index} header="✔" headerStyle={{ width: "5px", textAlign: "center" }}></Column>;
                })}
            </Row>
            {/* Nombre del día (dos digitos) */}
            <Row>
                <Column header="Asistencia por bloques" headerStyle={{ width: "100px", textAlign: "center" }} />
                {columnsDias?.map((dia, index) => {
                    return <Column key={index} header={dia.name} headerStyle={{ width: "5px", textAlign: "center" }}></Column>;
                })}
            </Row>
            {/* Numero de día */}
            <Row>
                <Column header="Nombre Alumno" field="alumno" headerStyle={{ width: "80px", textAlign: "center" }} />
                {columnsDias?.map((dia, index) => {
                    return <Column key={index} header={dia.num_dia} field={dia.num_dia} headerStyle={{ width: "5px", textAlign: "center" }}></Column>;
                })}
            </Row>
        </ColumnGroup>
    );

    return (
        <div className="datatable-scroll-demo">
            <Toast ref={toast} />
            <div className="card" style={{ height: "calc(100vh - 145px)" }}>
                <DataTable 
                    value={dataFicha}
                    //  paginator
                    id="13"
                    className="p-datatable-customers p-datatable-sm"
                    //rows={page}
                    dataKey="id"
                    //  onSelectionChange={(e) => checkFicha(e.value)}
                    emptyMessage="No existe información!"
                    //  rowsPerPageOptions={[8, 15, 30]}
                    loading={loading1}
                    header={header}
                    headerColumnGroup={headerGroup}
                    size="small"
                    showGridlines
                    scrollHeight="flex"
                    scrollable
                    scrollDirection="both"
                >
                    {/* <Column selectionMode="multiple" headerStyle={{ width: "3em" }}></Column>
                   
                      <Column field="fecha_matricula" header="Fecha" sortable body={bodyTemplateDate}></Column>  
                    <Column field="grado" header="Curso" headerStyle={{ width: "5px" }} body={bodyTemplate}></Column>
                    */}
                    <Column field="idalumno" header="Nro" headerStyle={{ width: "5px" }} body={bodyTemplateNro}></Column>
                    <Column field="alumno" header="Alumno" headerStyle={{ width: "45px" }} body={bodyTemplateAlumno}></Column>

                    {columnsDias?.map((dia, index) => {
                        return <Column key={index} field={dia.num_dia} header={dia.num_dia} bodyStyle={{ width: "5px", textAlign: "center" }} headerStyle={{ width: "5px", textAlign: "center" }} body={bodyTemplate}></Column>;
                    })}
                </DataTable>

                <Dialog header="Subir Archivo" visible={displayResponsive} onHide={() => setDisplayResponsive(false)} breakpoints={{ "960px": "75vw" }} style={{ width: "60vw" }} footer={renderFooter()}></Dialog>
            </div>
        </div>
    );
};
